var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ActionBase',{attrs:{"label":_vm.$t('validate'),"primary":true,"disabled":_vm.popinHasErrors},on:{"click":function($event){return _vm.handleClick()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }